// only available on web, native extension uses the default
// eslint-disable-next-line import/no-extraneous-dependencies
export {FormattedMessage} from "react-intl-phraseapp"
